import { inject, Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class CustomSocket {
  private socket!: Socket;
  private readonly configService = inject(ConfigService);

  connect(): void {
    if (this.socket?.connected) {
      return;
    }

    this.socket = io(this.configService.config.configWebSocket.url, this.configService.config.configWebSocket.options);
  }

  disconnect(): void {
    this.socket?.disconnect();
  }

  emit(event: string, data?: unknown): void {
    this.socket.emit(event, data);
  }

  fromEvent<T>(event: string): Observable<T> {
    return new Observable((observer) => {
      const listener = (data: T) => observer.next(data);
      this.socket.on(event, listener);
      return () => this.socket.off(event, listener);
    });
  }
}
